import { Body, Button, FlexBox, Headline, Icon } from '@Backlot-Cars/archie';
import { useTranslation } from 'next-i18next';
import { AuctionAccessAccountDetail } from '../../shared/AuctionAccessAccountDetail';
import { formatAuctionAccessId } from '../helpers';
import { LookupDetailsGrid } from '../../shared/styles';
import { trackAuctionAccessError } from '../tracking';

export const AccountAlreadyExists = ({ account, onContinueManually, signInUrl }) => {
	const { t } = useTranslation(['signup']);

	const handleLogin = () => {
		trackAuctionAccessError('login');
	};

	const handleRegisterAnother = () => {
		trackAuctionAccessError('register_another');
		onContinueManually();
	};

	return (
		<FlexBox flexDirection="column" gap="lg">
			<FlexBox alignItems="center" gap="sm">
				<Icon color="secondary" name="exclamation" size="smaller" />
				<Headline size="H3">{t('signup:auctionAccessLookup.accountExists.title')}</Headline>
			</FlexBox>
			<Body>{t('signup:auctionAccessLookup.accountExists.subTitle')}</Body>
			<FlexBox background="secondary" borderRadius="lg" flexDirection="column" gap="md" padding="lg">
				<Body bold>{t('signup:auctionAccessLookup.accountExists.accountFound')}</Body>
				<LookupDetailsGrid>
					<AuctionAccessAccountDetail
						label={t('signup:auctionAccessLookup.accountExists.name')}
						value={account?.name}
					/>
					<AuctionAccessAccountDetail
						label={t('signup:auctionAccessLookup.accountExists.email')}
						value={account?.email}
					/>

					<AuctionAccessAccountDetail
						label={t('signup:auctionAccessLookup.accountExists.mobilePhone')}
						value={account?.mobilePhone}
					/>
					<AuctionAccessAccountDetail
						label={t('signup:auctionAccessLookup.accountExists.auctionAccessId')}
						value={formatAuctionAccessId(account?.auctionAccessId)}
					/>
				</LookupDetailsGrid>
			</FlexBox>
			<FlexBox
				alignItems="center"
				flexDirection="row-reverse"
				flexWrap="wrap"
				gap="sm"
				justifyContent="space-between"
				width="100%"
			>
				<Button href={signInUrl} target="_self" onClick={handleLogin}>
					{t('signup:auctionAccessLookup.accountExists.logIn')}
				</Button>
				<Button type="button" variant="tertiary" onClick={handleRegisterAnother}>
					{t('signup:auctionAccessLookup.accountExists.registerAnotherDealership')}
				</Button>
			</FlexBox>
		</FlexBox>
	);
};
